module.exports = __webpack_public_path__ + "img/burger-icon.f2b2a4c0.svg";